<template>
  <div class="home-wrapper">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'HomeView',
  data() {
    return {}
  },
  mounted() {},
  methods: {},
}
</script>
<style scoped lang="less">
.home-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
}
</style>
